export const logoutEventType = 'cms-logout'
export type CmsLogoutEvent = CustomEvent<{
  isLockout: boolean | undefined;
}>

export const createAndEmitLogoutEvent = (isLockout?: boolean) => {
  const event: CmsLogoutEvent = new CustomEvent(
    logoutEventType,
    {
      bubbles: true,
      detail: {
        isLockout
      }
    }
  )
  document.dispatchEvent(event)
}
